import { useCountUp } from "@/hooks/useCountUp";
import { cn } from "@/lib/utils";

interface AnimatedNumberProps {
  value: number | undefined;
  isLoading?: boolean;
  className?: string;
}

export function AnimatedNumber({
  value,
  isLoading,
  className,
}: AnimatedNumberProps) {
  const display = useCountUp({
    target: value,
    enabled: !isLoading && value !== undefined,
  });

  return (
    <span className={cn("tabular-nums", className)} aria-live="polite">
      {display}
    </span>
  );
}
